import { render, staticRenderFns } from "./BasicWysiwyg.vue?vue&type=template&id=31511510&lang=pug"
import script from "./BasicWysiwyg.vue?vue&type=script&lang=ts"
export * from "./BasicWysiwyg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports